/* eslint-disable react/jsx-props-no-spreading */
import { Button } from '@efexteam/components';
import { RoleId, useRole } from '@efexteam/permission-manager';
import clsx from 'clsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import MissingClientInfo from '../../../pages/missing/MissingInfo';
import { selectSelectedLanguage } from '../../../pages/store/language/selectors';
import { EMPTY_STATE_CONFIG, EmptyStatePage } from './config';

interface EmptyStateProps {
  page: EmptyStatePage;
  submitLabel?: string;
  onSubmit?: () => void;
  buttonClassName?: string;
  wrapperClassName?: string;
  roleId?: RoleId;
  showTitle?: boolean;
}

const EmptyState = ({
  onSubmit,
  submitLabel,
  page,
  buttonClassName,
  wrapperClassName,
  showTitle = true,
}: EmptyStateProps) => {
  const selectLanguage = useSelector(selectSelectedLanguage);
  const { t } = useTranslation();
  const { isReadOnly } = useRole();

  const emptyStateConfig = useMemo(() => {
    if (page === 'clients' && isReadOnly) {
      return {
        ...EMPTY_STATE_CONFIG[page](selectLanguage.language),
        messageTitle: t('missingDataClientsTitle'),
        messageText: t('noPermissionsClients'),
      };
    }
    return EMPTY_STATE_CONFIG[page](selectLanguage.language);
  }, [page, isReadOnly, selectLanguage.language, t]);

  return (
    <div className={clsx('missing', wrapperClassName)}>
      <MissingClientInfo {...emptyStateConfig} showTitle={showTitle} />
      {submitLabel && (
        <div className="text-center">
          {!isReadOnly && (
            <Button
              appearance="primary"
              className={clsx('max-w-full', buttonClassName)}
              onClick={onSubmit}
            >
              {submitLabel}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
